module.exports = __webpack_public_path__ + "static/amelie_0-2bbbfa5320dce68a7285a31fd3500481.jpg";